<template>
  <div class="modal_box flex-col">
    <div class="select_wrap flex-row align-center">
      <zSelect
        v-model="queryParams.date"
        :options="selectList1"
        class="mr-10"
        @change="getList"
      />
      <zSelect
        v-model="queryParams.type"
        :options="selectList2"
        class="mr-10"
        @change="getList"
      />
    </div>
    <div class="list">
      <template v-if="data.list && data.list.length">
        <div
          v-for="item in data.list"
          :key="item.id"
          class="item"
          @click="jumpDetail(item)"
        >
          <div class="flex-row align-center">
            <div class="flex-col align-center flex-1">
              <div class="item_info flex-row align-center justify-between">
                <div class="flex-1">
                  <span class="f-w-b f-11">{{ item.memo }}</span>
                </div>
                <div class="f-12">
                  {{ item.money }}
                </div>
              </div>
              <div class="item_info bottom flex-row align-center justify-between">
                <div class="flex-1">
                  {{ item.createtime }}
                </div>
                <div class="f-11">
                  {{ $t("余额钱包") }}
                </div>
              </div>
            </div>
            <van-icon
              name="arrow"
              class="go_icon"
            />
          </div>
        </div>
      </template>
      <zEmpty v-else />
    </div>
    <div class="bottom_content flex-row flex-wrap align-center">
      <div class="bottom_item flex-row">
        <span class="text">{{ $t('存款总额') }}</span>
        <span class="green">R${{ data.total_recharge || '0.00' }}</span>
      </div>
      <div class="bottom_item flex-row">
        <span class="text">{{ $t("提款总额") }}</span>
        <span class="red">R${{ data.total_withdraw || '0.00' }}</span>
      </div>
      <div class="bottom_item flex-row">
        <span class="text">{{ $t("累计总数") }}</span>
        <span class="yellow">R${{ data.bonus || '0.00' }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import zSelect from '../../../components/zSelect.vue';
import zEmpty from '../../../components/zEmpty.vue';
import Fetch from "../../../utils/fetch";
export default {
  components: {
    zSelect,
    zEmpty
  },
  data() {
    return {
      queryParams: {
        date: 0,
        type: '',
      },
      selectList1: [
        {
          value: 'Hoje',
          key: 0
        },
        {
          value: 'Ontem',
          key: 1
        },
        {
          value: 'Últimos 7 Dias',
          key: 7
        },
        {
          value: 'Últimos 15 Dias',
          key: 15
        },
        {
          value: 'Últimos 30 Dias',
          key: 30
        },
      ],
      selectList2: [],
      data: {
        list: [],
        bonus: "0.00",
        total_recharge: "0.00",
        total_withdraw: "0.00"
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList(e) {
      Fetch("/record/moneyLog", this.queryParams, { method: 'get' }).then((r) => {
        if (r.data) {
          this.data = r.data;
          this.selectList2 = r.data.dictionary.map(item => ({
            value: item.title,
            key: item.name
          }))
          if (!e) {
            this.queryParams.type = this.selectList2[0].key
          }
        }
      });
    },
    jumpDetail(item) {
      this.$router.push({
        path: '/report/detail',
        query: {
          id: item.id
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
@import "../../../assets/css/variables.less";
@import "./comment.less";

.modal_box {
  height: 100%;
}

.select_wrap {
  padding: 10px;
  // overflow-x: auto;
}

.bottom_content {
  height: 48px;
  box-sizing: border-box;
  font-size: 11px;
  width: 100%;
  background-color: @secondary-color;
  padding: 5px 10px;

  .bottom_item {
    width: 50%;
    color: @textcolor5;
    padding-right: 20px;
    box-sizing: border-box;

    .text {
      width: 110px;
    }
  }
}

.list {
  flex: 1;
  height: 1%;
  overflow-y: auto;
  padding-bottom: 20px;
  padding: 0 10px 20px;

  .item {
    padding: 10px;
    border-radius: 5px;
    color: @textcolor3;
    font-size: 10px;

    &:nth-child(odd) {
      background-color: @secondary-color;
    }

    .go_icon {
      font-size: 15px;
      color: @anttextcolor;
    }
  }

  .item_info {
    width: 100%;
    padding-right: 10px;
    box-sizing: border-box;

    &:first-child {
      margin-bottom: 5px;
    }

    &.bottom {
      color: @textcolor5;
    }
  }
}

.green {
  color: #04be02;
}

.red {
  color: #ff4a4a;
}

.yellow {
  color: #ffaa09;
}
</style>